import C from "../../../constants";

var constructPayload = function(store, question) {
    const state = store.getState();

    // I only want the fullsize images
    const histories = state.questionHistory.filter(ans => ((ans.file && ans.file.isJPEG) || (ans.tamperedMedia && ans.tamperedMedia[0].file && ans.tamperedMedia[0].file.isJPEG)));
    const files = histories.map(hist => hist.file || hist.tamperedMedia[0].file);

    var formData;
    if (files && files[0]) {
        formData = new FormData();
        formData.append("image", files[0]);
    }

    return formData;
};

var handleResult = function(result, store, question) {
    console.info("PhoneExamination Result: " + result.data);
    store.dispatch({ type: C.STORE_RESULT_DATA, result: result.data });
    store.dispatch({ type: C.NEXT_QUESTION });
}

var handleError = function(error) {
    console.error("PhoneExamination Error: " + error.message);
    if (error.stack) {
        console.error(error.stack);
    }
}

export {
    constructPayload,
    handleResult,
    handleError
};